/* eslint-disable vue/valid-v-slot */
<template>
  <v-row>
    <v-row>
      <v-col class="align-left">
        <ExpandCollapseToggle
          id="notesPanelToggle"
          @toggleAllPanels="toggleAllPanels"
          styleClass="mt-3"
          :panel="panel"
        />
      </v-col>
      <v-col class="align-right mt-2">
        <ValidationCountsHeader v-if="moduleType == MODULE_TYPES.MANAGEMENT" />
      </v-col>
    </v-row>
    <v-col sm="12" md="12" lg="12" xl="12" class="pa-0">
      <v-expansion-panels v-model="panel" multiple color="#fff">
        <v-expansion-panel style="margin-top: 20px" @group:selected="checkFormValidation">
          <v-expansion-panel-title
            class="d-flex justify-start"
            hide-actions
            expand-icon="fa-solid fa-plus"
            collapse-icon="fa-solid fa-minus"
          >
            <v-icon v-if="!panel.includes(0)" icon="fa-solid fa-plus" />

            <v-icon v-if="panel.includes(0)" icon="fa-solid fa-minus" />

            <h3>Structure Inspection Notes</h3>
          </v-expansion-panel-title>

          <v-expansion-panel-text>
            <v-row>
              <v-col class="px-0">
                <v-btn
                  :disabled="!isEditable || anyEditableInspectionNotes"
                  id="btn_add_Inspection_Note"
                  variant="outlined"
                  class="my-2 ml-1"
                  @click="addInspectionNotes()"
                  >Add Note</v-btn
                >
              </v-col>
            </v-row>
            <v-row>
              <v-col sm="12">
                <v-form v-model="validInspection" ref="inspectionNotesForm">
                  <v-data-table
                    id="inspection_Table"
                    v-model:page="pageInspection.page"
                    :items="inspectionNotes"
                    :headers="inspectionHeaders"
                    :items-per-page="pageInspection.itemsPerPage"
                    hide-default-footer
                  >
                    <template v-slot:[`header.commentType`]="{ column }">
                      <v-row align="center">
                        <v-col cols="12" class="pa-0">
                          {{ column.title.split(" ")[0] }}
                        </v-col>
                        <v-col cols="12" class="pa-0">
                          {{ column.title.split(" ")[1] }}
                        </v-col>
                        <v-col cols="12" class="pa-0">
                          {{ column.title.split(" ")[2] }}
                        </v-col>
                      </v-row>
                    </template>
                    <template v-slot:[`header.notes`]="{ column }">
                      <v-row class="pb-6" align="center">
                        <v-col cols="12" class="pa-0">
                          {{ column.title.split(" ")[0] }}
                        </v-col>
                        <v-col cols="12" class="pa-0">
                          {{ column.title.split(" ")[1] }}
                        </v-col>
                      </v-row>
                    </template>
                    <template v-slot:[`header.action`]="{ column }">
                      {{ column.title }}
                    </template>
                    <template v-slot:[`item.commentType`]="{ item }">
                      <LabelSelect
                        v-if="item.isAdd && !item.readOnly"
                        :style="validInspection ? 'padding-bottom: 22px' : ''"
                        :selectXl="12"
                        :selectLg="12"
                        :selectMd="12"
                        :selectSm="12"
                        id="Note_Type"
                        :options="getInspectionNotesCommentTypes"
                        :isEditable="true"
                        isRequired
                        v-model="item.tempCommentType"
                        @update:modelValue="changesDetectedInspectionNotes = true"
                      ></LabelSelect>
                      <div v-else :class="!item.readOnly ? 'pb-5' : 'pb-0'">
                        {{ noteTypeIN01(item.commentType) }}
                      </div>
                    </template>
                    <template v-slot:[`item.notes`]="{ item }">
                      <LabelText
                        v-if="!item.readOnly"
                        :textXl="12"
                        :textLg="12"
                        :textMd="12"
                        :textSm="12"
                        id="textarea_Inspection_Notes"
                        v-model="item.notes"
                        @update:modelValue="changesDetectedInspectionNotes = true"
                        :isEditable="true"
                        :counter="commentsMaxLength"
                        :maxlength="commentsMaxLength"
                        persistent-counter
                        type="textarea"
                        auto-grow
                        rows="1"
                      >
                      </LabelText>
                      <div style="overflow-wrap: anywhere" v-else>
                        {{ item.notes }}
                      </div>
                    </template>
                    <template v-slot:[`item.action`]="{ item }">
                      <div style="white-space: nowrap" v-if="!item.readOnly && isEditable">
                        <IconTooltip
                          id="icon_Inspection_Update"
                          icon="fa-solid fa-check"
                          :tooltip="item.isAdd ? 'Add' : 'Update'"
                          @click="saveInspectionNotes(item)"
                        />
                        <IconTooltip
                          id="icon_Inspection_Close"
                          icon="fa-solid fa-xmark"
                          tooltip="Close"
                          @click="closeInspectionNotes"
                        />
                      </div>
                      <div style="white-space: nowrap" v-else-if="isEditable && !anyEditableInspectionNotes">
                        <IconTooltip
                          id="icon_Inspection_Edit"
                          icon="fa-solid fa-pencil"
                          tooltip="Edit"
                          @click="editInspectionNotes(item)"
                        />
                        <IconTooltip
                          id="icon_Inspection_Delete"
                          icon="fa-solid fa-trash"
                          tooltip="Delete"
                          @click="deleteInspectionNotes(item)"
                        />
                      </div>
                    </template>
                    <template v-slot:bottom>
                      <DataTableFooter
                        id="inspection_Notes_DataTable_Footer"
                        :items="inspectionNotes"
                        v-model="pageInspection"
                        ref="updateInspectionPage"
                        @update:modelValue="scrollToDataTable('inspection_Table')"
                      ></DataTableFooter>
                    </template>
                  </v-data-table>
                </v-form>
              </v-col>
            </v-row>
          </v-expansion-panel-text>
        </v-expansion-panel>

        <v-expansion-panel @group:selected="checkSubFormValidation">
          <v-expansion-panel-title
            class="d-flex justify-start"
            hide-actions
            expand-icon="fa-solid fa-plus"
            collapse-icon="fa-solid fa-minus"
          >
            <v-icon v-if="!panel.includes(1)" icon="fa-solid fa-plus" />

            <v-icon v-if="panel.includes(1)" icon="fa-solid fa-minus" />

            <h3>Structure Unit Inspection Notes</h3>
          </v-expansion-panel-title>

          <v-expansion-panel-text>
            <v-row>
              <v-col class="px-0">
                <v-btn
                  :disabled="!isEditable || anyEditableSubInspectionNotes"
                  id="btn_add_Sub_Inspection_Note"
                  variant="outlined"
                  class="my-2 ml-1"
                  @click="addSubInspectionNotes()"
                  >Add Note</v-btn
                >
              </v-col>
            </v-row>
            <v-row>
              <v-col sm="12">
                <v-form v-model="validSubInspection" ref="subInspectionNotesForm">
                  <v-data-table
                    id="sub_Table"
                    v-model:page="subPageInspection.page"
                    :items="subInspectionNotes"
                    :headers="subInspectionHeaders"
                    :items-per-page="subPageInspection.itemsPerPage"
                    hide-default-footer
                  >
                    <template v-slot:[`header.strUnitKey`]="{ column }">
                      <v-row align="center">
                        <v-col cols="12" class="pa-0">
                          {{ column.title.split(" ")[0] }}
                        </v-col>
                        <v-col cols="12" class="pa-0">
                          {{ column.title.split(" ")[1] }}
                        </v-col>
                        <v-col cols="12" class="pa-0">
                          {{ column.title.split(" ")[2] }}
                        </v-col>
                      </v-row>
                    </template>
                    <template v-slot:[`header.commentType`]="{ column }">
                      <v-row align="center">
                        <v-col cols="12" class="pa-0">
                          {{ column.title.split(" ")[0] }}
                        </v-col>
                        <v-col cols="12" class="pa-0">
                          {{ column.title.split(" ")[1] }}
                        </v-col>
                        <v-col cols="12" class="pa-0">
                          {{ column.title.split(" ")[2] }}
                        </v-col>
                      </v-row>
                    </template>
                    <template v-slot:[`header.notes`]="{ column }">
                      <v-row class="pb-6" align="center">
                        <v-col cols="12" class="pa-0">
                          {{ column.title.split(" ")[0] }}
                        </v-col>
                        <v-col cols="12" class="pa-0">
                          {{ column.title.split(" ")[1] }}
                        </v-col>
                      </v-row>
                    </template>
                    <template v-slot:[`header.action`]="{ column }">
                      {{ column.title }}
                    </template>
                    <template v-slot:[`item.strUnitKey`]="{ item }">
                      <LabelSelect
                        v-if="item.isAdd && !item.readOnly"
                        :style="validSubInspection ? 'padding-bottom: 22px' : ''"
                        :selectXl="12"
                        :selectLg="12"
                        :selectMd="12"
                        :selectSm="12"
                        isRequired
                        id="New_SubStructure_Type"
                        :options="notesValue.structureUnitLocations"
                        :isEditable="true"
                        v-model="item.tempStructureUnitId"
                        @update:modelValue="
                          {
                            changesDetectedSubInspectionNotes = true;
                            item.tempCommentType = null;
                          }
                        "
                      ></LabelSelect>
                      <div v-else-if="item.structureUnitId" :class="!item.readOnly ? 'pb-5' : 'pb-0'">
                        {{ getSubStructureLocation(item.structureUnitId) }}
                      </div>
                      <div v-else :class="!item.readOnly ? 'pb-5' : 'pb-0'"></div>
                    </template>
                    <template v-slot:[`item.commentType`]="{ item }">
                      <LabelSelect
                        :style="validSubInspection ? 'padding-bottom: 22px' : ''"
                        v-if="item.isAdd && !item.readOnly"
                        :selectXl="12"
                        :selectLg="12"
                        :selectMd="12"
                        :selectSm="12"
                        isRequired
                        id="selected_Sub_Note_Type"
                        :options="getSubInspectionNotesCommentTypes"
                        :isEditable="true"
                        v-model="item.tempCommentType"
                        @update:modelValue="changesDetectedSubInspectionNotes = true"
                      ></LabelSelect>
                      <div v-else :class="!item.readOnly ? 'pb-5' : 'pb-0'">
                        {{ noteTypeIN04(item.commentType) }}
                      </div>
                    </template>
                    <template v-slot:[`item.notes`]="{ item }">
                      <LabelText
                        v-if="!item.readOnly"
                        :textXl="12"
                        :textLg="12"
                        :textMd="12"
                        :textSm="12"
                        id="textarea_Sub_Inspection_Notes"
                        v-model="item.notes"
                        @update:modelValue="changesDetectedSubInspectionNotes = true"
                        :isEditable="true"
                        :counter="commentsMaxLength"
                        :maxlength="commentsMaxLength"
                        persistent-counter
                        type="textarea"
                        auto-grow
                        rows="1"
                      >
                      </LabelText>
                      <div style="overflow-wrap: anywhere" v-else>
                        {{ item.notes }}
                      </div>
                    </template>
                    <template v-slot:[`item.action`]="{ item }">
                      <div style="white-space: nowrap" v-if="!item.readOnly && isEditable">
                        <IconTooltip
                          id="icon_Sub_Inspection_Update"
                          icon="fa-solid fa-check"
                          :tooltip="item.isAdd ? 'Add' : 'Update'"
                          @click="saveSubInspectionNotes(item)"
                        />
                        <IconTooltip
                          id="icon_Sub_Inspection_Close"
                          icon="fa-solid fa-xmark"
                          tooltip="Close"
                          @click="closeSubInspectionNotes"
                        />
                      </div>
                      <div style="white-space: nowrap" v-else-if="isEditable && !anyEditableSubInspectionNotes">
                        <IconTooltip
                          id="icon_Sub_Inspection_Edit"
                          icon="fa-solid fa-pencil"
                          tooltip="Edit"
                          @click="editSubInspectionNotes(item)"
                        />
                        <IconTooltip
                          id="icon_Sub_Inspection_Delete"
                          icon="fa-solid fa-trash"
                          tooltip="Delete"
                          @click="deleteSubInspectionNotes(item)"
                        />
                      </div>
                    </template>
                    <template v-slot:bottom>
                      <DataTableFooter
                        id="sub_Inspection_Notes_DataTable_Footer"
                        :items="subInspectionNotes"
                        v-model="subPageInspection"
                        ref="updateSubPage"
                        @update:modelValue="scrollToDataTable('sub_Table')"
                      ></DataTableFooter>
                    </template>
                  </v-data-table>
                </v-form>
              </v-col> </v-row
          ></v-expansion-panel-text>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-col>
  </v-row>
  <ConfirmDialog ref="closeConfirm" :cancelButtonText="BUTTONS.NO" />
</template>

<script>
import { defineComponent, ref, computed, watch, nextTick, onMounted } from "vue";
import { useInspectionStore } from "@/stores/inspection";
import { useConfigStore } from "@/stores/config";
import { ENV_CONFIG_PROPERTY } from "@/constants/EnvConfigProperties";
import ConfirmDialog from "@/components/common/ConfirmDialog.vue";
import { BUTTONS } from "@/constants/CommonWebConstants";
import { clone } from "@/util/clone";
import { INSPECTION_MESSAGES, MODULE_TYPES } from "@/constants/InspectionConstants";
import IconTooltip from "@/components/common/IconTooltip.vue";
import LabelText from "@/components/common/LabelText.vue";
import LabelSelect from "@/components/common/LabelSelect.vue";
import DataTableFooter from "@/components/common/DataTableFooter.vue";
import { REFERENCE_TABLE } from "@/constants/ReferenceTables";
import { LOGGER } from "@/util/logger";
import { scrollToDataTable } from "@/util/scrollToElement";
import useNotesData from "@/composables/notesData";
import ExpandCollapseToggle from "@/components/shared/ExpandCollapseToggle.vue";
import { useSnackbarStore } from "@/stores/snackbar";
import { SNACKBAR_MARKER } from "@/constants/GlobalSnackbar.js";
import { useQuickSearchStore } from "@/stores/quickSearch";
import { storeToRefs } from "pinia";
import { useNotesStore } from "@/components/inspection/store/notes";
import { INSPECTION_STATUSES } from "@/constants/InspectionStatuses";
import { useUserPermissionStore } from "@/stores/userPermission";
import { INSPECTION_LINKS_JOINTS_PERMISSIONS } from "@/rbac";
import { ACCESS_LEVELS } from "@/rbac/accessLevels.js";
import { useInspectionLinksStore } from "@/stores/inspectionLinks";
import { useUserStore } from "@/stores/userStore";
import ValidationCountsHeader from "@/components/shared/ValidationCountsHeader.vue";
import { STRUCTURE_UNIT_TYPE } from "@/constants/Inspections";

export default defineComponent({
  name: "InspectionNotes",
  props: {
    moduleType: { default: MODULE_TYPES.INSPECTION },
  },
  data() {
    return {
      inspectionHeaders: [
        {
          title: "IN.01 Note Type",
          sortable: false,
          key: "commentType",
          width: "25%",
        },
        {
          title: "IN.02 Note",
          sortable: false,
          key: "notes",
        },
        {
          title: "Action",
          sortable: false,
          key: "action",
          width: "5%",
        },
      ],
      subInspectionHeaders: [
        {
          title: "IN.03 Structure Unit",
          sortable: false,
          key: "strUnitKey",
          width: "15%",
        },
        {
          title: "IN.04 Note Type",
          sortable: false,
          key: "commentType",
          width: "22%",
        },
        {
          title: "IN.05 Note",
          sortable: false,
          key: "notes",
        },
        {
          title: "Action",
          sortable: false,
          key: "action",
          width: "5%",
        },
      ],
    };
  },
  setup(props) {
    const { noteTypeIN01, noteTypeIN04, sortSubInspectionNotes } = useNotesData();
    const allPanels = [0, 1];
    const panel = ref(allPanels);
    const inspectionStore = useInspectionStore();
    const configStore = useConfigStore();
    const userStore = useUserStore();
    const snackbarStore = useSnackbarStore();
    const structure = computed(() => inspectionStore.selectedInspection);
    const isEditable = computed(() => {
      if (props.moduleType == MODULE_TYPES.MANAGEMENT) {
        return hasQuickSearchSucceeded.value && notesValue?.value?.brkey && hasAccessToEdit.value;
      } else {
        return inspectionStore.isEditable;
      }
    });
    const userPermissionStore = useUserPermissionStore();
    const quickSearchStore = useQuickSearchStore();
    const { hasQuickSearchSucceeded } = storeToRefs(quickSearchStore);
    const commentsMaxLength = computed(() => {
      return configStore.getEnvConfigValue(ENV_CONFIG_PROPERTY.INSPECTION_COMMENT_MAX_LENGTH);
    });
    const subUnitStructureUnitNoteTypes = computed(() => {
      const envConfigValue = configStore.getEnvConfigValue(ENV_CONFIG_PROPERTY.SUB_UNIT_STRUCTURE_UNIT_NOTE_TYPES);
      return envConfigValue
        .split(",")
        .map((t) => t?.trim())
        .sort();
    });
    const spanStructureUnitNoteTypes = computed(() => {
      const envConfigValue = configStore.getEnvConfigValue(ENV_CONFIG_PROPERTY.SPAN_STRUCTURE_UNIT_NOTE_TYPES);
      return envConfigValue
        .split(",")
        .map((t) => t?.trim())
        .sort();
    });
    const inspectionLinksStore = useInspectionLinksStore();
    const closeConfirm = ref(null);
    const valid = ref(true);
    let addingAndEditingInspectionNotes = false;
    let addingAndEditingSubNotes = false;
    let notesValue = ref({});
    let resetDirty = ref(false);
    let notesStore = useNotesStore();
    function setAddingOrEditing() {
      if (!addingAndEditingInspectionNotes && !addingAndEditingSubNotes) {
        inspectionStore.setAddingOrEditing(false);
      }
    }

    let inspectionNotesSnackbarId = ref("");
    let substructureNotesSnackbarId = ref("");
    //Inspection Notes
    let changesDetectedInspectionNotes = ref(false);
    let inspectionNotes = ref([]);
    let newInspectionNote = null;
    let updateInspectionPage = ref(null);
    let brkey = ref("");
    let inspectionId = ref("");
    let pageInspection = ref({
      itemsPerPage: 30,
      page: 1,
    });
    let validInspection = ref(false);
    let inspectionNotesForm = ref(null);
    async function validate() {
      inspectionNotesForm.value.validate();
      subInspectionNotesForm.value.validate();
    }
    const structureHeader = computed(() => quickSearchStore.getStructure());

    const hasAccessToEdit = computed({
      get() {
        if (structureHeader.value?.INSPECTIONSTATUS === INSPECTION_STATUSES.ACCEPTED) {
          return userPermissionStore.checkUserPermission(
            INSPECTION_LINKS_JOINTS_PERMISSIONS[ACCESS_LEVELS.CUSTOM.EDIT_APPROVED_INSPECTION],
            userPermissionStore.getUserPermissionByBrkeyFromCache(notesValue.value.brkey),
          );
        } else {
          return userPermissionStore.checkUserPermission(
            INSPECTION_LINKS_JOINTS_PERMISSIONS[ACCESS_LEVELS.EDIT],
            userPermissionStore.getUserPermissionByBrkeyFromCache(notesValue.value.brkey),
          );
        }
      },
    });

    onMounted(async () => {
      await readData();
    });

    const convertToInspectionNotesObject = (detail) => {
      if (detail.isAdd) {
        return {
          brkey: detail.brkey,
          inspectionId: detail.inspectionId,
          commentType: detail.tempCommentType,
          updateDateTime: detail.updateDateTime,
          notes: detail.notes,
          updateUserId: detail.updateUserId,
        };
      } else {
        return {
          brkey: detail.brkey,
          inspectionId: detail.inspectionId,
          commentType: detail.commentType,
          updateDateTime: detail.updateDateTime,
          notes: detail.notes,
          updateUserId: detail.updateUserId,
        };
      }
    };
    const readData = async () => {
      notesValue.value = {};
      resetDirty.value = true;
      brkey.value = "";
      inspectionId.value = "";
      if (props.moduleType == MODULE_TYPES.MANAGEMENT && structureHeader.value?.BRKEY) {
        if (!hasQuickSearchSucceeded.value) {
          resetDirty.value = true;
          return;
        }
        await notesStore.loadDataObject(
          props.moduleType,
          structureHeader.value.BRKEY,
          structureHeader.value.INSPECTIONID,
        );
        notesValue.value = notesStore.getNotes();
      } else if (props.moduleType == MODULE_TYPES.INSPECTION) {
        const structure = computed(() => inspectionStore.selectedInspection);
        brkey.value = structure.value.structureBridge.brkey;
        inspectionId.value = structure.value.inspection.inspectionId;
        await notesStore.loadDataObject(props.moduleType, null, null, structure.value);
        notesValue.value = notesStore.getNotes();
      }
      getInspectionNotes();
      getSubInspectionNotes();
      resetDirty.value = true;
    };

    const sortInspectionNotes = () => {
      inspectionNotes.value?.sort((a, b) => {
        if (Number.parseInt(a.commentType) < Number.parseInt(b.commentType)) {
          return -1;
        } else if (Number.parseInt(a.commentType) > Number.parseInt(b.commentType)) {
          return 1;
        } else return 0;
      });
    };

    const getInspectionNotes = () => {
      inspectionNotes.value = clone(notesValue.value.inspectionComments);

      if (!inspectionNotes.value) {
        //remove null values from array(if any)
        inspectionNotes.value = inspectionNotes.value?.filter((a) => !!a);
      }
      if (inspectionNotes.value) {
        for (const i of inspectionNotes.value ?? []) {
          i.readOnly = true;
          i.isAdd = false;
        }
      }
      sortInspectionNotes();
    };
    getInspectionNotes();

    function getSubStructureLocation(structureUnitId) {
      return notesValue.value?.structureUnitLocations?.find(
        (strUnitLocation) => strUnitLocation.value == structureUnitId,
      )?.title;
    }

    const closeInspectionNotes = () => {
      if (isEditable.value && changesDetectedInspectionNotes.value) {
        //show confirmation dialog on closing
        closeConfirm.value
          .open(INSPECTION_MESSAGES.DETECT_DATATABLE_CHANGE_CONFIRMATION_MESSAGE, BUTTONS.YES)
          .then((response) => {
            if (!response) {
              getInspectionNotes();
              newInspectionNote = null;
              changesDetectedInspectionNotes.value = false;
              addingAndEditingInspectionNotes = false;
              setAddingOrEditing();
              snackbarStore.removeMessage(inspectionNotesSnackbarId.value);
              isEditing.value = false;
            }
          });
      } else {
        newInspectionNote = null;
        snackbarStore.removeMessage(inspectionNotesSnackbarId.value);
        addingAndEditingInspectionNotes = false;
        setAddingOrEditing();
        getInspectionNotes();
        isEditing.value = false;
      }
    };

    const getInspectionNotesCommentTypes = computed(() => {
      let commentTypes = configStore.getReferenceValues(
        REFERENCE_TABLE.INSPECTION_COMMENT_TYPE,
        null,
        null,
        null,
        null,
        true,
      );

      const noteTypes = [];
      for (const note of inspectionNotes.value ?? []) {
        noteTypes.push(note.commentType);
      }

      const servTypOn = computed({
        get() {
          return props.moduleType === MODULE_TYPES.MANAGEMENT
            ? structureHeader.value.SERVTYPON
            : structure.value.structureBridge.servTypOn;
        },
      });

      const structureInfo = configStore.serviceTypes.find((f) => f.servTypOn === servTypOn.value);

      const allowedTypes = new Set(
        configStore.commentsFilters
          .filter((f) => f.structureType.includes(structureInfo.structureType))
          .map((f) => Number.parseInt(f.commentTypeCode)),
      );

      return commentTypes
        .filter(
          (commentType) =>
            allowedTypes.has(Number.parseInt(commentType.value)) && !noteTypes.includes(commentType.value),
        )
        .sort((a, b) => {
          if (Number.parseInt(a.value) < Number.parseInt(b.value)) {
            return -1;
          } else if (Number.parseInt(a.value) > Number.parseInt(b.value)) {
            return 1;
          }
          return 0;
        });
    });

    const editInspectionNotes = (detail) => {
      addingAndEditingInspectionNotes = true;
      isEditing.value = true;
      inspectionStore.setAddingOrEditing(true);
      inspectionNotesSnackbarId.value = snackbarStore.showMessage({
        displayText: INSPECTION_MESSAGES.INSPECTION_NOTES_SAVE_MESSAGE,
      });
      detail.readOnly = false;
      changesDetectedInspectionNotes.value = false;
    };

    const deleteInspectionNotes = (detail) => {
      const deleteIndex = notesValue.value.inspectionComments.findIndex((a) => a?.commentType == detail?.commentType);
      if (deleteIndex > -1) {
        notesValue.value.inspectionComments.splice(deleteIndex, 1);
        getInspectionNotes();
        inspectionLinksStore.isDirty = true;
      }
    };

    const anyEditableInspectionNotes = computed(() => {
      return inspectionNotes.value?.some((element) => !element.readOnly);
    });

    const addInspectionNotes = () => {
      addingAndEditingInspectionNotes = true;
      inspectionStore.setAddingOrEditing(true);
      isEditing.value = true;
      if (props.moduleType == MODULE_TYPES.MANAGEMENT) {
        newInspectionNote = {
          brkey: structureHeader.value.BRKEY,
          inspectionId: structureHeader.value.INSPECTIONID,
          tempCommentType: "",
          isAdd: true,
          readOnly: false,
          commentType: "",
          updateDateTime: new Date().toISOString(),
          notes: "",
          updateUserId: userStore.loggedInUser?.sub,
        };
      } else {
        newInspectionNote = {
          brkey: structure.value.structureBridge.brkey,
          inspectionId: structure.value.inspection.inspectionId,
          tempCommentType: "",
          isAdd: true,
          readOnly: false,
          commentType: "",
          updateDateTime: new Date().toISOString(),
          notes: "",
          updateUserId: userStore.loggedInUser?.sub,
        };
      }
      inspectionNotes.value.unshift(newInspectionNote);
      inspectionNotesSnackbarId.value = snackbarStore.showMessage({
        displayText: INSPECTION_MESSAGES.INSPECTION_NOTES_SAVE_MESSAGE,
      });
      changesDetectedInspectionNotes.value = false;
      nextTick(() => {
        updateInspectionPage.value?.setPageValue(1);
        inspectionNotesForm.value.validate();
        scrollToDataTable("select_Note_Type");
      });
    };

    const saveInspectionNotes = (detail) => {
      inspectionNotesForm.value
        .validate()
        .then(() => {
          if (validInspection.value) {
            validationSnackbar.value = false;
            if (!notesValue.value?.inspectionComments?.[0]) {
              //remove null values from array(if any)
              notesValue.value.inspectionComments = notesValue.value.inspectionComments?.filter((a) => !!a);
            }
            if (detail.isAdd) {
              notesValue.value.inspectionComments.push(convertToInspectionNotesObject(newInspectionNote));
            } else {
              //update existing
              const updateIndex = notesValue.value.inspectionComments.findIndex(
                (a) => a?.commentType == detail?.commentType,
              );
              notesValue.value.inspectionComments.splice(updateIndex, 1, convertToInspectionNotesObject(detail));
            }
            //if all required fields entered - close the expanded row
            newInspectionNote = null;
            isEditing.value = false;
            changesDetectedInspectionNotes.value = false;
            snackbarStore.removeMessage(inspectionNotesSnackbarId.value);
            addingAndEditingInspectionNotes = false;
            detail.readOnly = true;
            getInspectionNotes();
            setAddingOrEditing();
          } else {
            validationSnackbar.value = true;
          }
        })
        .catch((err) => {
          LOGGER.logException(err);
          newInspectionNote = null;
          changesDetectedInspectionNotes.value = false;
          snackbarStore.removeMessage(inspectionNotesSnackbarId.value);
          getInspectionNotes();
          addingAndEditingInspectionNotes = false;
          setAddingOrEditing();
        });
    };

    const saveChanges = async () => {
      const structure = inspectionStore.selectedInspection;
      const isSuccess = await notesStore.saveData(props.moduleType, notesValue.value, structure);
      if (isSuccess) {
        inspectionLinksStore.isDirty = false;
        if (props.moduleType == MODULE_TYPES.INSPECTION) {
          await notesStore.loadDataObject(props.moduleType, null, null, notesValue.value);
        }
        notesValue.value = notesStore.getNotes();
        // Using this flag to not set the dirty flag in watch
        resetDirty.value = true;
      }
      return isSuccess;
    };

    let validationSnackbar = computed({
      get() {
        if (props.moduleType === MODULE_TYPES.MANAGEMENT) {
          return inspectionLinksStore.showValidationSnackbar;
        } else {
          return inspectionStore.getShowValidationSnackbar;
        }
      },
      set(value) {
        if (props.moduleType === MODULE_TYPES.MANAGEMENT) {
          inspectionLinksStore.showValidationSnackbar = value;
        } else {
          inspectionStore.setShowValidationSnackbar(value);
        }
      },
    });

    const cancelChanges = async () => {
      //only called from Inspection Links
      notesValue.value = notesStore.getNotes();
      getInspectionNotes();
      getSubInspectionNotes();
      // Using this flag to not set the dirty flag in watch
      resetDirty.value = true;
      inspectionLinksStore.isDirty = false;
    };

    //Sub Inspection Notes

    let changesDetectedSubInspectionNotes = ref(false);

    let subInspectionNotes = ref([]);

    let newSubInspectionNote = null;

    let subPageInspection = ref({
      itemsPerPage: 30,
      page: 1,
    });
    let updateSubPage = ref(null);

    let validSubInspection = ref(false);

    let subInspectionNotesForm = ref(null);

    let isEditing = computed({
      get() {
        return inspectionLinksStore.isAddingOrEditingNotes;
      },
      set(value) {
        inspectionLinksStore.isAddingOrEditingNotes = value;
      },
    });

    const convertToSubInspectionNotesObject = (detail) => {
      if (detail.isAdd) {
        return {
          inspectionId: Number.parseInt(detail.inspectionId),
          structureUnitId: Number.parseInt(detail.tempStructureUnitId),
          commentType: detail.tempCommentType,
          updateDateTime: detail.updateDateTime,
          notes: detail.notes,
          updateUserId: detail.updateUserId,
        };
      } else {
        return {
          inspectionId: Number.parseInt(detail.inspectionId),
          commentType: detail.commentType,
          structureUnitId: Number.parseInt(detail.structureUnitId),
          updateDateTime: detail.updateDateTime,
          notes: detail.notes,
          updateUserId: detail.updateUserId,
        };
      }
    };

    const getSubInspectionNotes = () => {
      subInspectionNotes.value = clone(notesValue.value.structureUnitInspComments);

      if (!subInspectionNotes.value?.[0]) {
        //remove null values from array(if any)
        subInspectionNotes.value = subInspectionNotes.value?.filter((a) => !!a);
      }
      for (let idx = 1; idx <= subInspectionNotes.value?.length; idx++) {
        subInspectionNotes.value[idx - 1].readOnly = true;
        subInspectionNotes.value[idx - 1].isAdd = false;
      }
      sortSubInspectionNotes(subInspectionNotes.value, notesValue.value.structureUnits);
    };
    getSubInspectionNotes();

    const getSubInspectionNotesCommentTypes = computed(() => {
      const addNote = subInspectionNotes.value.find((note) => note.isAdd);
      const subCommentTypes = configStore.getReferenceValues(REFERENCE_TABLE.SUBSTRUCTURE_COMMENT_TYPE);

      if (!addNote) {
        return subCommentTypes;
      }

      const structureUnit = notesValue.value.structureUnits.find(
        (unit) => unit.structureUnitId == addNote.tempStructureUnitId,
      );
      const legacyType = structureUnit?.legacyStructureType;

      // Determine which note types to include based on structure unit type
      let allowedNoteTypes = null;
      if ([STRUCTURE_UNIT_TYPE.APPROACH, STRUCTURE_UNIT_TYPE.MAIN, STRUCTURE_UNIT_TYPE.CULVERT].includes(legacyType)) {
        allowedNoteTypes = spanStructureUnitNoteTypes.value;
      } else if ([STRUCTURE_UNIT_TYPE.PIER, STRUCTURE_UNIT_TYPE.ABUTMENT].includes(legacyType)) {
        allowedNoteTypes = subUnitStructureUnitNoteTypes.value;
      }

      if (!allowedNoteTypes) {
        return subCommentTypes;
      }

      // Filter to allowed types and exclude already-used types for this structure unit
      return subCommentTypes
        .filter(
          (subCommentType) =>
            allowedNoteTypes.includes(subCommentType.value) &&
            !isSubInspectionNoteAlreadyUsed(subCommentType.value, addNote),
        )
        .sort();
    });

    const isSubInspectionNoteAlreadyUsed = (commentType, addNote) =>
      subInspectionNotes.value.some(
        (note) =>
          note.commentType === commentType &&
          Number.parseInt(note.structureUnitId) === Number.parseInt(addNote.tempStructureUnitId),
      );

    const closeSubInspectionNotes = () => {
      if (isEditable.value && changesDetectedSubInspectionNotes.value) {
        //show confirmation dialog on closing
        closeConfirm.value
          .open(INSPECTION_MESSAGES.DETECT_DATATABLE_CHANGE_CONFIRMATION_MESSAGE, BUTTONS.YES)
          .then((response) => {
            if (!response) {
              addingAndEditingSubNotes = false;
              setAddingOrEditing();
              getSubInspectionNotes();
              newSubInspectionNote = null;
              snackbarStore.removeMessage(substructureNotesSnackbarId.value);
              changesDetectedSubInspectionNotes.value = false;
              isEditing.value = false;
            }
          });
      } else {
        newSubInspectionNote = null;
        snackbarStore.removeMessage(substructureNotesSnackbarId.value);
        addingAndEditingSubNotes = false;
        setAddingOrEditing();
        getSubInspectionNotes();
        isEditing.value = false;
      }
    };

    const editSubInspectionNotes = (detail) => {
      addingAndEditingSubNotes = true;
      isEditing.value = true;
      inspectionStore.setAddingOrEditing(true);
      detail.readOnly = false;
      substructureNotesSnackbarId.value = snackbarStore.showMessage({
        displayText: INSPECTION_MESSAGES.SUBSTRUCTURE_INSPECTION_NOTES_SAVE_MESSAGE,
      });
      changesDetectedSubInspectionNotes.value = false;
    };

    const deleteSubInspectionNotes = (detail) => {
      const deleteIndex = notesValue.value.structureUnitInspComments.findIndex(
        (a) => a?.commentType == detail?.commentType && a?.structureUnitId  == detail?.structureUnitId,
      );
      if (deleteIndex > -1) {
        notesValue.value.structureUnitInspComments.splice(deleteIndex, 1);
        getSubInspectionNotes();
      }
    };

    const anyEditableSubInspectionNotes = computed(() => {
      return subInspectionNotes.value?.some((element) => !element.readOnly);
    });

    const addSubInspectionNotes = () => {
      addingAndEditingSubNotes = true;
      isEditing.value = true;
      inspectionStore.setAddingOrEditing(true);

      if (props.moduleType == MODULE_TYPES.MANAGEMENT) {
        newSubInspectionNote = {
          inspectionId: structureHeader.value.INSPECTIONID,
          isAdd: true,
          readOnly: false,
          commentType: "",
          tempCommentType: "",
          tempStructureUnitId: "",
          updateDateTime: new Date().toISOString(),
          notes: "",
          updateUserId: userStore.loggedInUser?.sub,
        };
      } else {
        newSubInspectionNote = {
          inspectionId: structure.value.inspection.inspectionId,
          isAdd: true,
          readOnly: false,
          commentType: "",
          tempCommentType: "",
          tempStructureUnitId: "",
          updateDateTime: new Date().toISOString(),
          notes: "",
          updateUserId: userStore.loggedInUser?.sub,
        };
      }

      subInspectionNotes.value.unshift(newSubInspectionNote);
      substructureNotesSnackbarId.value = snackbarStore.showMessage({
        displayText: INSPECTION_MESSAGES.SUBSTRUCTURE_INSPECTION_NOTES_SAVE_MESSAGE,
      });
      changesDetectedSubInspectionNotes.value = false;
      nextTick(() => {
        updateSubPage.value?.setPageValue(1);
        subInspectionNotesForm.value.validate();
        scrollToDataTable("select_New_SubStructure_Type");
      });
    };

    const saveSubInspectionNotes = (detail) => {
      subInspectionNotesForm.value
        .validate()
        .then(() => {
          if (validSubInspection.value) {
            validationSnackbar.value = false;
            if (!notesValue.value?.structureUnitInspComments?.[0]) {
              //remove null values from array(if any)
              notesValue.value.structureUnitInspComments = notesValue.value.structureUnitInspComments?.filter(
                (a) => !!a,
              );
            }
            if (detail.isAdd) {
              notesValue.value.structureUnitInspComments.push(convertToSubInspectionNotesObject(newSubInspectionNote));
            } else {
              //update existing
              const updateIndex = notesValue.value.structureUnitInspComments.findIndex(
                (a) => a?.commentType == detail?.commentType && a?.structureUnitId == detail?.structureUnitId,
              );
              notesValue.value.structureUnitInspComments.splice(
                updateIndex,
                1,
                convertToSubInspectionNotesObject(detail),
              );
            }
            //if all required fields entered - close the expanded row
            newSubInspectionNote = null;
            isEditing.value = false;
            changesDetectedSubInspectionNotes.value = false;
            snackbarStore.removeMessage(substructureNotesSnackbarId.value);
            getSubInspectionNotes();
            addingAndEditingSubNotes = false;
            setAddingOrEditing();
          } else {
            validationSnackbar.value = true;
          }
        })
        .catch((err) => {
          LOGGER.logException(err);
          newSubInspectionNote = null;
          changesDetectedSubInspectionNotes.value = false;
          snackbarStore.removeMessage(substructureNotesSnackbarId.value);
          getSubInspectionNotes();
          addingAndEditingSubNotes = false;
          setAddingOrEditing();
        });
    };

    const checkFormValidation = (value) => {
      //add validation only when the expansion panel is expanded(value = true)
      if (value) {
        nextTick(() => {
          inspectionNotesForm.value.validate();
        });
      }
    };

    const checkSubFormValidation = (value) => {
      //add validation only when the expansion panel is expanded(value = true)
      if (value) {
        nextTick(() => {
          subInspectionNotesForm.value.validate();
        });
      }
    };

    const toggleAllPanels = (expandAll) => {
      if (expandAll) {
        panel.value = allPanels;
      } else {
        panel.value = [];
      }
    };

    const printD491 = () => {
      return { reportPage: "D491-Insp-Notes-Screen", marker: SNACKBAR_MARKER.NOTES };
    };

    // watch those objects used in component from structure to warn about unsaved changes
    watch(
      () => [props],
      () => {
        inspectionStore.setDirtyFlag(true);
      },
      { deep: true },
    );

    watch(
      [notesValue],
      () => {
        // This watch will NOT be triggered during initial onMounted()
        if (props.moduleType === MODULE_TYPES.MANAGEMENT) {
          // for management module
          if (resetDirty.value) {
            inspectionLinksStore.isDirty = false;
            resetDirty.value = false;
          } else {
            inspectionLinksStore.isDirty = true;
          }
        } else if (props.moduleType === MODULE_TYPES.INSPECTION) {
          // for inspection  module
          if (resetDirty.value) {
            inspectionStore.setDirtyFlag(false);
            resetDirty.value = false;
          } else {
            inspectionStore.setDirtyFlag(true);
          }
        }
      },
      { deep: true },
    );

    return {
      getSubInspectionNotes,
      getInspectionNotes,
      readData,
      saveChanges,
      cancelChanges,
      validate,
      notesValue,
      valid,
      updateInspectionPage,
      updateSubPage,
      newSubInspectionNote,
      newInspectionNote,
      structure,
      subPageInspection,
      pageInspection,
      changesDetectedSubInspectionNotes,
      changesDetectedInspectionNotes,
      getSubInspectionNotesCommentTypes,
      getInspectionNotesCommentTypes,
      subInspectionNotes,
      saveSubInspectionNotes,
      addSubInspectionNotes,
      anyEditableSubInspectionNotes,
      deleteSubInspectionNotes,
      editSubInspectionNotes,
      closeSubInspectionNotes,
      inspectionNotes,
      saveInspectionNotes,
      addInspectionNotes,
      anyEditableInspectionNotes,
      deleteInspectionNotes,
      editInspectionNotes,
      closeInspectionNotes,
      configStore,
      commentsMaxLength,
      closeConfirm,
      BUTTONS,
      validSubInspection,
      subInspectionNotesForm,
      validInspection,
      inspectionNotesForm,
      isEditable,
      panel,
      REFERENCE_TABLE,
      inspectionStore,
      scrollToDataTable,
      checkFormValidation,
      checkSubFormValidation,
      noteTypeIN01,
      getSubStructureLocation,
      noteTypeIN04,
      toggleAllPanels,
      printD491,
      MODULE_TYPES,
    };
  },
  components: {
    ConfirmDialog,
    IconTooltip,
    LabelText,
    LabelSelect,
    DataTableFooter,
    ExpandCollapseToggle,
    ValidationCountsHeader,
  },
});
</script>

<style scoped lang="scss">
@use "@/styles/colors" as c;

.v-expansion-panel-title,
.v-expansion-panel-title:hover {
  background-color: c.$p-pa-light-blue !important;
}

h3 {
  order: 1;
  color: c.$p-white !important;
}

.v-expansion-panel-title__icon {
  order: 0;
}
</style>
